import { SERVICES } from "@/lib/services";

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28">
        <div className="max-w-3xl mb-14">
          <span className="font-heading font-bold uppercase text-sm tracking-widest text-[#E60000]">
            What we do
          </span>
          <h2 className="font-heading font-black uppercase tracking-tight text-3xl md:text-5xl mt-3">
            Services built to keep you running
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t-2 border-l-2 border-black">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${i}`}
                className="group relative border-b-2 border-r-2 border-black p-8 bg-white hover:bg-black transition-colors duration-200"
              >
                <div className="h-12 w-12 flex items-center justify-center border-2 border-black bg-[#E60000] text-white mb-6 group-hover:bg-white group-hover:text-[#E60000] transition-colors">
                  <Icon className="h-6 w-6" strokeWidth={2} />
                </div>
                <h3 className="font-heading font-bold text-xl mb-2 group-hover:text-white transition-colors">
                  {s.title}
                </h3>
                <p className="text-black/70 group-hover:text-white/70 transition-colors leading-relaxed">
                  {s.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
